import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import SimpleModal from 'ui/Modals/SimpleModal';
import { useGetOfficialGrades } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/hooks/officialGrades';
import { GradeMapping } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';
import OfficialGradeSelector from 'routes/HumanResourcesModule/Settings/HrGrade/components/OfficialGradeSelector';
import TreeViewLoading from 'routes/Mappings/components/PayComponentsTable/components/TreeViewLoading';
import { usePutGradeMappingMutation } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/hooks/gradeMapping';
import { formatOfficialGradesTree } from 'routes/HumanResourcesModule/Settings/HrGrade/components/helpers/treeHelpers';

type Props = {
    gradeMapping?: GradeMapping | null;
    showModal: boolean;
    setShowModal: (arg: boolean) => void;
};
export default function EditGradeMappingModal({
    gradeMapping = null,
    showModal,
    setShowModal,
}: Props) {
    const { t } = useTranslation();
    const updateGradeMappingMutation = usePutGradeMappingMutation();
    const { data: officialGradesData, isLoading: isOfficialGradesLoading } =
        useGetOfficialGrades();

    const officialGrades = officialGradesData || [];

    const [selectedGradeId, setSelectedGradeId] = useState<number | null>(
        gradeMapping?.officialGrade?.id || null,
    );
    const officialGradesTree = formatOfficialGradesTree(officialGrades);

    const dialogTitle = gradeMapping
        ? t('humanResources.simulation.mappingOf', {
              grade: gradeMapping.nonOfficialGrade,
              filiere: gradeMapping.nonOfficialFiliere,
          })
        : '';

    const onConfirm = () => {
        setShowModal(false);
        if (gradeMapping !== null) {
            updateGradeMappingMutation.mutate({
                nonOfficialGradeId: gradeMapping.id,
                officialGradeId: selectedGradeId,
            });
        }
    };

    return (
        <SimpleModal
            open={showModal}
            onClose={() => setShowModal(false)}
            dialogTitle={dialogTitle}
            additionalButtons={[
                <Button
                    key={gradeMapping?.id}
                    onClick={onConfirm}
                    variant="contained"
                    sx={{ ml: '1rem' }}
                    disabled={isOfficialGradesLoading}
                >
                    {t('common.confirm')}
                </Button>,
            ]}
        >
            {isOfficialGradesLoading ? (
                <TreeViewLoading />
            ) : (
                <OfficialGradeSelector
                    selectedGradeId={selectedGradeId}
                    setSelectedGradeId={setSelectedGradeId}
                    officialGradesTree={officialGradesTree}
                />
            )}
        </SimpleModal>
    );
}
